import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selector',
  standalone: false
})
export class SelectorPipe implements PipeTransform {
  transform(
    lookFor: unknown,
    collection: unknown[],
    filterFunction: (item: unknown, lookFor: unknown) => boolean,
    selectFunction: (item: unknown) => unknown): unknown {

    if (!lookFor || !collection || collection.length === 0) {
      return '';
    }
    let returnObject = lookFor;
    if (filterFunction) {
      returnObject = collection.filter(item => filterFunction(item, lookFor));
    }

    if (selectFunction) {
      returnObject = selectFunction(returnObject);
    }
    
    return returnObject;
  }
}